export default __webpack_public_path__ + "static/media/betting.325ddc28.svg";